export const SOCIAL_SHARE = {
  HomePage:
    'https://images.ctfassets.net/mmgv7yhaaeds/6ZfCD9roGItdCOf0CtpRGN/cf96f76e0fb12ce56402f5793e173c10/home-2025-social-share.png',
  AppBuilder:
    'https://images.ctfassets.net/mmgv7yhaaeds/5bmS2lHempXdfhsEeY1WaM/2e87cf558bdd06f1316d33281695331c/social-sharing-app-builder.jpg',
  Blog: 'https://images.ctfassets.net/mmgv7yhaaeds/7pYlwjBiBJwmWZxvMP1V5Z/394711bad1e7cef6e4c90bc1ddc977ce/social-sharing-blog.png',
  Resources:
    'https://images.ctfassets.net/mmgv7yhaaeds/1CIaiy8L869VpMTmTzzmVw/d41ef289870bf331436870e2049cc66b/social-sharing-events.png',
  Magic:
    'https://images.ctfassets.net/mmgv7yhaaeds/4qnvxNANCTfjowdG6mt8uC/4cbeeb9e72d53ac436eef2be12eea474/social-sharing-magic.png',
  Integrations:
    'https://images.ctfassets.net/mmgv7yhaaeds/6vzq21nhnBE39BLXvVZCVs/327cca00b9b98c4cad489300a654529d/social-sharing-integrations.png',
  UseCases:
    'https://images.ctfassets.net/mmgv7yhaaeds/1UoCbP7qjl4VpoiSWRHMVN/ae1abf6866586d3c93e74d60a80510a2/social-sharing-gallery.png',
  FurtherReading:
    'https://images.ctfassets.net/mmgv7yhaaeds/7pYlwjBiBJwmWZxvMP1V5Z/394711bad1e7cef6e4c90bc1ddc977ce/social-sharing-blog.png',
  Newsroom:
    'https://images.ctfassets.net/mmgv7yhaaeds/3qe5Nyfqu6soOyepsz9CIF/19165a33dee4d0d7cfc414d904544051/social-sharing-newsroom.png',
  Notebooks:
    'https://images.ctfassets.net/mmgv7yhaaeds/2SF9B23QFak59iLg85scha/e43c40ebc616f7fc7a1fd856afc0b8d4/social-sharing-notebooks.png',
  HowToHex:
    'https://images.ctfassets.net/mmgv7yhaaeds/sg2FxoMmJolXUu4csdo7b/2ac58638838162ab1a7e8802d1851f3f/How-to-Hex-0605-OpenGraph-Image-1200x630.jpg',
  Pricing:
    'https://images.ctfassets.net/mmgv7yhaaeds/7fXbQ3gTnO3MUO64rYb5d4/a668395141a96a0a88724b8643b64580/social-sharing-pricing.png',
  Security:
    'https://images.ctfassets.net/mmgv7yhaaeds/3XuARY5BhoHB4ZODAj9DIc/75510459d399875e0ca41260ce3141f6/social-sharing-security.png',
  SnowflakeSummit2025:
    'https://images.ctfassets.net/mmgv7yhaaeds/3LFPTkaA21esFrOA6M8AYm/fa3217b1d2b2541f808829d93f2898d8/snowflakesummit-2025-social-share.png',
  Gartner2025:
    'https://images.ctfassets.net/mmgv7yhaaeds/7DpJcpgaoPhXdEUkVnYDp/067bca8a089d56e9b2d14bc4563d6e99/2025-Gartner.png',
  MakeYourDataTeamUnstoppable:
    'https://images.ctfassets.net/mmgv7yhaaeds/1WwFnazT0pqCdpOpuuDWOJ/8b263482b2803e46dce74188168cdef1/social-share-make-your-data-team-unstopabble.png',
  SnowparkContainerServices:
    'https://images.ctfassets.net/mmgv7yhaaeds/3Ox6uPyIJRPSWMjkYIPEdL/954b09e863883017fcdf665587948299/integrations-snowpark-lp.png',
  HexThreePointOh:
    'https://images.ctfassets.net/mmgv7yhaaeds/w279eljUTZ7h467tQUSbj/165f0ad4e3773526b892644ec4c2a776/hex-3-0-live-social-image-1200-630.jpg',
  ForTeams:
    'https://images.ctfassets.net/mmgv7yhaaeds/531TdmGDMzT1Ri7wKIbvEG/fbd67deb1f14858208acfb2e39ec4296/social-sharing-for-teams.png',
  DbtCoalesce2024:
    'https://images.ctfassets.net/mmgv7yhaaeds/5VpVo0x959DrJJFMvsi4sU/93ecbd01eb8e712612722d92f23dc207/coalesce-2024-ogimage.png',
  HexVsNotebooks:
    'https://images.ctfassets.net/mmgv7yhaaeds/6WNQkwvJxOIk6y0Ppl3agY/36ca77918fd04f74e11813426080f441/social-sharing-hex-vs-traditional-notebooks.jpg',
  Careers:
    'https://images.ctfassets.net/mmgv7yhaaeds/6qRk3kCqnaxE2pVV3PuxwH/5f89a1c7ae056fa11039a5d0539794cb/social-sharing-were-hiring.png',
  UseCaseDataScience:
    'https://images.ctfassets.net/mmgv7yhaaeds/4RXo2PgD5lDSggDPZd7Oq5/c0a24f203733b0008979c1a01d3ee2c3/social-sharing-data-science.png',
  UseCaseExploratoryAnalytics:
    'https://images.ctfassets.net/mmgv7yhaaeds/7s8mb0z2FqOzFN2k97N6WF/58624104a236d3af98649a8bab2efa34/social-sharing-exploratory-analytics.png',
  UseCaseOpertionalReporting:
    'https://images.ctfassets.net/mmgv7yhaaeds/7twxDJsq1Am1OvRe9kwdV3/7c7e1496f44155cd0bbda49fe6904793/social-sharing-operational-reporting.png',
  UseCaseSelfServe:
    'https://images.ctfassets.net/mmgv7yhaaeds/4JqrjyMhbC01AoU0PDQ6QQ/bf11442d8a206f320d8475829ba336e9/social-sharing-self-serve.png',
  Explore:
    'https://images.ctfassets.net/mmgv7yhaaeds/60GOaLDjHgqQFYBj4sECsv/59b74771c720dfd8116fd9b828c7ff82/social-sharing-explore.png',
  Enterprise:
    'https://images.ctfassets.net/mmgv7yhaaeds/YLir1ooXPZiHuEJsM9Dxy/95eddb22f1dc00191fef3a336559ca4a/social-sharing-enterprise.png',
  Customers:
    'https://images.ctfassets.net/mmgv7yhaaeds/pKnOquA4szJbS62UlDoCh/404e281cd46c60c8613130bb205b8a5a/social-sharing-customers.png',
  Partners:
    'https://images.ctfassets.net/mmgv7yhaaeds/IBtQo3VVuyjR9MulyzWVZ/08bc0e4b9feda7225600ddac9ed72c4b/social-sharing-partners.png',
  BRLDA:
    'https://images.ctfassets.net/mmgv7yhaaeds/57ihKOuIj5ZmgdswqzF0xo/e42ef79ea654d7449c77673309faaa7f/social-sharing-brlda.jpg',
  EmbeddedAnalytics:
    'https://images.ctfassets.net/mmgv7yhaaeds/3Qmbs3vipwE3khO2RIouiT/0297bd99432383ef12c4d0aa9d62e2d9/social-sharing-embedded-analytics.png',
  ClubHex:
    'https://images.ctfassets.net/mmgv7yhaaeds/6mOwqch2BryukLnumjQh4D/d94b9d35f4ed3f828d954f674f9bbd78/og-image-club-hex.jpg',
  ClubHexVIP:
    'https://images.ctfassets.net/mmgv7yhaaeds/1vl4esMhKgflDLGS9iOHgH/24e72706417719871f24d0fbdbade6fe/club-hex-vip.png'
};
